import styled from 'styled-components'

export const OrderedListNumber = styled.div`
  ${({ theme }) => `
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${theme.fontSize.md};
    font-weight: ${theme.fontWeight.bold};
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: 0.74px;
    text-align: center;
    border-radius: 100%;
    background-color: ${theme.palette.info100};
    color: ${theme.palette.white};
    flex-shrink: 0;
  `}
`

export const StepBox = styled.div`
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.step-with-warning {
    .warning {
      display: none;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      align-items: flex-start;
      flex-direction: column;

      .warning {
        display: flex;
      }
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      align-items: flex-start;
      flex-direction: column;

      .warning {
        display: flex;
      }
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      display: flex;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
      align-items: center;
      flex-direction: row;

      .warning {
        display: flex;
      }
    }
  }

  &.form {
    justify-content: flex-start;
    height: 52px;
  }

  &.step3 {
    align-items: flex-start;

    .actions {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      flex-direction: column;
      flex-shrink: 0;

      div.desc-wrapper {
        margin-top: ${({ theme }) => theme.space.xxxs};
        display: flex;
        flex-direction: column;

        span.desc {
          margin-right: ${({ theme }) => theme.space.xs};
        }

        button {
          margin-top: ${({ theme }) => theme.space.xxs};
          width: max-content;
          height: 34px;
        }
      }

      @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
        div.desc-wrapper {
          display: inline-flex;

          button {
            display: inline-flex;
          }
        }
      }

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        display: inline-flex;

        div.desc-wrapper {
          flex-direction: row;
          align-items: center;

          button {
            margin-top: 0;
            flex-shrink: 0;
          }
        }
      }
    }
  }
`

export const StepLabel = styled.div`
  ${({ theme }) => `
    margin-left: ${theme.space.xs};
    font-size: ${theme.fontSize.md};
    font-weight: ${theme.fontWeight.bold};
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: 0.73px;
  `}
`

export const StepWarningLabel = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`

export const StepLabelDesc = styled.div`
  ${({ theme }) => `
    font-size: ${theme.fontSize.xs};
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: 0.56px;
  `}
`

export const Paddings = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: block;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: block;
    flex-wrap: wrap;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: block;
  }
`

export const LoaderWrapper = styled.div`
  ${({ theme }) => `
    .label {
      display: flex;
      align-items: center;
      margin-bottom: 18px;

      .step {
        margin-right: ${theme.space.xs};
      }
    }

    .form {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;

      .fields {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        [aria-live="polite"] {
          margin-right: ${theme.space.xs};
          margin-bottom: ${theme.space.xs};
        }
      }

      &.xs {
        [aria-live="polite"] {
          width: 100%;

          .react-loading-skeleton {
            width: 100% !important;
          }
        }
      }
    }

    .xs {
      display: flex;
    }

    .md {
      display: none;
    }

    @media (min-width: ${theme.breakpoints.sm}) {
      .xs {
        display: none;
      }

      .md {
        display: flex;
      }
    }
  `}
`
